import { Close } from '@mui/icons-material';
import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const CreateCajaModal = ({ open, onClose, onCrear, vendedores, allTarifas, loading }) => {

  const [nombreCaja, setNombreCaja] = useState("");
  const [vendedor, setVendedor] = useState(null);
  const [tarifasSeleccionadas, setTarifasSeleccionadas] = useState([]);

  const handleSubmit = () => {
    if (!nombreCaja || !vendedor || tarifasSeleccionadas.length === 0) return;
    onCrear({
      nombre: nombreCaja,
      idusuario: vendedor.id,
      tarifas: tarifasSeleccionadas.map(t => t.id)
    });

    setNombreCaja("");
    setVendedor(null);
    setTarifasSeleccionadas([]);
  };

  return (
    <Dialog open={open} /* onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleCloseModal();
        }
      }} */
      disableEscapeKeyDown
      maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0062" }}>
            Crear caja
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 0, color: "#0b0062" }}>Nombre de la caja <span style={{ color: "red" }}>*</span></Typography>
        <TextField
          sx={{
            fontFamily: "Bricolage Grotesque",
            mb: 2,
            '& .MuiInputBase-input-MuiOutlinedInput-input': {
              fontFamily: "Bricolage Grotesque",
            },
            '& label.Mui-focused': {
              color: '#5656FF',
              fontFamily: "Bricolage Grotesque"
            },
            '& .MuiOutlinedInput-root': {
              height: "40px",
              '& fieldset': {
                borderColor: '#B2BAC2',
              },
              '&:hover fieldset': {
                borderColor: '#5656ff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#5656ff',
              },
            }
          }}
          value={nombreCaja}
          onChange={e => setNombreCaja(e.target.value)}
          fullWidth
          margin="none"
        />
        <Typography sx={{ mb: 0, color: "#0b0062" }}>Vendedor <span style={{ color: "red" }}>*</span></Typography>
        <Autocomplete
          sx={{
            fontFamily: "Bricolage Grotesque",
            mb: 2,
            '& .MuiInputBase-input': {
              fontFamily: "Bricolage Grotesque",
            },
            '& label.Mui-focused': {
              color: '#5656FF',
              fontFamily: "Bricolage Grotesque"
            },
            '& .MuiOutlinedInput-root': {
              minHeight: "40px",
              '& fieldset': {
                borderColor: '#B2BAC2',
              },
              '&:hover fieldset': {
                borderColor: '#5656ff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#5656ff',
              },
            },
            '& .MuiAutocomplete-inputRoot': {
              fontFamily: "Bricolage Grotesque",
              minHeight: "40px",
              paddingTop: "0px !important",
              paddingBottom: "0px !important",
            },
            '& .MuiAutocomplete-input': {
              fontFamily: "Bricolage Grotesque",
            }
          }}

          options={vendedores}
          getOptionLabel={v => `${v.nombre} ${v.apellido} (${v.email})`}
          value={vendedor}
          onChange={(_, val) => setVendedor(val)}
          renderInput={params => <TextField {...params} /* label="Vendedor" */ margin="none" />}
        />
        <Typography sx={{ mb: 0, color: "#0b0062" }}>Tarifas <span style={{ color: "red" }}>*</span></Typography>
        <Autocomplete
          sx={{
            fontFamily: "Bricolage Grotesque",
            mb: 2,
            '& .MuiInputBase-input': {
              fontFamily: "Bricolage Grotesque",
            },
            '& label.Mui-focused': {
              color: '#5656FF',
              fontFamily: "Bricolage Grotesque"
            },
            '& .MuiOutlinedInput-root': {
              minHeight: "40px",
              '& fieldset': {
                borderColor: '#B2BAC2',
              },
              '&:hover fieldset': {
                borderColor: '#5656ff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#5656ff',
              },
            },
            '& .MuiAutocomplete-inputRoot': {
              fontFamily: "Bricolage Grotesque",
              minHeight: "40px",
              paddingTop: "0px !important",
              paddingBottom: "0px !important",
            },
            '& .MuiAutocomplete-input': {
              fontFamily: "Bricolage Grotesque",
            }
          }}
          multiple
          options={allTarifas}
          getOptionLabel={t => `${t.concepto} - $${t.precio}`}
          value={tarifasSeleccionadas}
          onChange={(_, val) => setTarifasSeleccionadas(val)}
          renderInput={params => <TextField {...params} /* label="Tarifas"  */ margin="none" />}
        />
      </DialogContent>
      <DialogActions sx={{
        padding: window.innerWidth <= 576 ? "12px" : "0 16px 16px", display: "flex",
        flexWrap: window.innerWidth <= 576 ? "wrap" : "nowrap", gap: "10px"
      }}>
        <Button sx={{
          border: "1px solid #5656FF",
          color: "#5656FF",
          padding: "5px 10px",
          borderRadius: "4px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: window.innerWidth <= 576 ? "13px" : "14px",
          width: "100%",
        }}
          onClick={onClose}>Cancelar</Button>
        <Button
          sx={{
            marginLeft: "0 !important",
            backgroundColor: "#5656FF",
            color: "white",
            padding: "5px 10px",
            borderRadius: "4px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: window.innerWidth <= 576 ? "13px" : "14px",
            width: "100%"
          }}
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || !nombreCaja || !vendedor || tarifasSeleccionadas.length === 0}
        >
          {loading ? <CircularProgress size={20} /> : "Crear"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CreateCajaModal;